import { useQuery } from 'react-query';
import { useAuth } from './useAuth';
import { agentApi } from '@/services/agentApi';

export const applicationsOverviewKey = (userId?: string, agentId?: string) =>
  ['applications-overview', userId ?? null, agentId ?? null] as const;

/** One bounded account-scoped request; never retain another account's rows. */
export const useApplicationsOverview = () => {
  const { user } = useAuth();
  return useQuery(
    applicationsOverviewKey(user?.id, user?.agentProfile?.id),
    async ({ signal }) => {
      const result = await agentApi.getApplications({
        page: 1,
        limit: 5,
        sortBy: 'updatedAt',
        sortOrder: 'desc',
        includeSubAccounts: false,
      }, signal);
      if (!Array.isArray(result?.applications) || !Number.isInteger(result.total) ||
          result.total < 0 || result.applications.length > 5 ||
          (result.total > 0 && result.applications.length === 0) ||
          result.applications.length > result.total) {
        throw new Error('Applications overview returned inconsistent data');
      }
      return result;
    },
    {
      enabled: Boolean(user?.id && user?.agentProfile?.id),
      staleTime: 0,
      cacheTime: 0,
      keepPreviousData: false,
      retry: false,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: 60_000,
      refetchIntervalInBackground: false,
    },
  );
};
